import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LocationProvider } from "./context/LocationContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import HotelsPage from "./pages/HotelsPage";
import HotelDetailPage from "./pages/HotelDetailPage";
import RentalsPage from "./pages/RentalsPage";
import RentalDetailPage from "./pages/RentalDetailPage";
import RentalCheckoutPage from "./pages/RentalCheckoutPage";
import MyRentalsPage from "./pages/MyRentalsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import OtpLoginPage from "./pages/OtpLoginPage";
import BookingsPage from "./pages/BookingsPage";
import AdminPage from "./pages/AdminPage";
import HelpPage from "./pages/HelpPage";
import CheckoutPage from "./pages/CheckoutPage";
import VerificationPage from "./pages/VerificationPage";
import PartnerHotelsPage from "./pages/PartnerHotelsPage";
import PartnerRoomsPage from "./pages/PartnerRoomsPage";
import PartnerBookingsPage from "./pages/PartnerBookingsPage";
import PartnerReportsPage from "./pages/PartnerReportsPage";
import PayoutsPage from "./pages/PayoutsPage";
import RentalAgreementPage from "./pages/RentalAgreementPage";
import ChatPage from "./pages/ChatPage";
import WishlistPage from "./pages/WishlistPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ReferralPage from "./pages/ReferralPage";
import PaymentReturnPage from "./pages/PaymentReturnPage";
import PartnerAgreementPage from "./pages/PartnerAgreementPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ScarcityBanner from "./components/ScarcityBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import InstallAppButton from "./components/InstallAppButton";
import ManifestSwitcher from "./components/ManifestSwitcher";
import { isAdminHost } from "./hooks/useAdminSubdomain";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <BrowserRouter>
          <ManifestSwitcher />
          <div className="App bg-bone min-h-screen flex flex-col">
            <ScarcityBanner />
            <Navbar />
            <main className="flex-1">
              <Routes>
                {isAdminHost() && (
                  <Route path="/" element={<Navigate to="/admin" replace />} />
                )}
                {!isAdminHost() && (
                  <Route path="/" element={<HomePage />} />
                )}
                <Route path="/hotels" element={<HotelsPage />} />
                <Route path="/hotels/:id" element={<HotelDetailPage />} />
                <Route path="/rentals" element={<RentalsPage />} />
                <Route path="/rentals/:id" element={<RentalDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/otp-login" element={<OtpLoginPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/bookings" element={<ProtectedRoute><BookingsPage /></ProtectedRoute>} />
                <Route path="/my-rentals" element={<ProtectedRoute><MyRentalsPage /></ProtectedRoute>} />
                <Route path="/checkout/:bookingId" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
                <Route path="/rental-checkout/:rentalId" element={<ProtectedRoute><RentalCheckoutPage /></ProtectedRoute>} />
                <Route path="/verification" element={<ProtectedRoute><VerificationPage /></ProtectedRoute>} />
                <Route path="/payouts" element={<ProtectedRoute><PayoutsPage /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
                <Route path="/partner/hotels" element={<ProtectedRoute roles={["hotel_partner","admin"]}><PartnerHotelsPage /></ProtectedRoute>} />
                <Route path="/partner/bookings" element={<ProtectedRoute roles={["hotel_partner","admin"]}><PartnerBookingsPage /></ProtectedRoute>} />
                <Route path="/partner/reports" element={<ProtectedRoute roles={["hotel_partner","admin"]}><PartnerReportsPage /></ProtectedRoute>} />
                <Route path="/partner/rooms" element={<ProtectedRoute roles={["room_partner","admin"]}><PartnerRoomsPage /></ProtectedRoute>} />
                <Route path="/rentals/:rentalId/agreement" element={<ProtectedRoute><RentalAgreementPage /></ProtectedRoute>} />
                <Route path="/chat/:rentalId" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
                <Route path="/chat/booking/:bookingId" element={<ProtectedRoute><ChatPage scope="booking" /></ProtectedRoute>} />
                <Route path="/wishlist" element={<ProtectedRoute><WishlistPage /></ProtectedRoute>} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/referral" element={<ProtectedRoute><ReferralPage /></ProtectedRoute>} />
                <Route path="/payment/return" element={<ProtectedRoute><PaymentReturnPage /></ProtectedRoute>} />
                <Route path="/partner-agreement" element={<PartnerAgreementPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" richColors />
            <InstallAppButton />
          </div>
        </BrowserRouter>
      </LocationProvider>
    </AuthProvider>
  );
}
export default App;
